module.exports = __webpack_public_path__ + "img/911b33f9ca2954142c3cbdf28d69da6c.svg";